<div class="page-deposit">
    @if(currentScreenSize === 'xSmall'){
        <app-deposit-mobile></app-deposit-mobile>
    }@else {
        <app-deposit-desktop></app-deposit-desktop>
    }
</div>
